/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Performance_IntelligenceInputs */

const en_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance Intelligence`)
};

const es_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencia de rendimiento`)
};

const fr_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence de la Performance`)
};

const de_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance Intelligence`)
};

const ja_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パフォーマンス・インテリジェンス`)
};

const zh_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`业务表现智能分析`)
};

const ar_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليلات الأداء الذكية`)
};

const id_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecerdasan Performa`)
};

const it_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi delle Prestazioni`)
};

const ru_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ производительности`)
};

const pt_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligência de Desempenho`)
};

const ko_performance_intelligence = /** @type {(inputs: Performance_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`퍼포먼스 인텔리전스`)
};

/**
* | output |
* | --- |
* | "Performance Intelligence" |
*
* @param {Performance_IntelligenceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const performance_intelligence = /** @type {((inputs?: Performance_IntelligenceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Performance_IntelligenceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_performance_intelligence(inputs)
	if (locale === "es") return es_performance_intelligence(inputs)
	if (locale === "fr") return fr_performance_intelligence(inputs)
	if (locale === "de") return de_performance_intelligence(inputs)
	if (locale === "ja") return ja_performance_intelligence(inputs)
	if (locale === "zh") return zh_performance_intelligence(inputs)
	if (locale === "ar") return ar_performance_intelligence(inputs)
	if (locale === "id") return id_performance_intelligence(inputs)
	if (locale === "it") return it_performance_intelligence(inputs)
	if (locale === "ru") return ru_performance_intelligence(inputs)
	if (locale === "pt") return pt_performance_intelligence(inputs)
	return ko_performance_intelligence(inputs)
});